<template>
  <div v-if="items.length" class="page-home-videos">
    <Title class="mb-4" dark>Vídeos</Title>
    <div class="page-home-videos-list">
      <VideoCard
        v-for="({ id, title, link, date }, i) in items"
        :key="i"
        :id="id"
        :title="title"
        :link="link"
        :date="date"
        :type="getCardType(i)"
        dark
      ></VideoCard>
    </div>
    <div class="d-flex justify-center mt-8">
      <v-btn
        to="/videos"
        color="secondary lighten-2"
        class="text-capitalize px-4"
        depressed
        tile
      >
        Mais Vídeos
      </v-btn>
    </div>
  </div>
</template>

<script>
import Title from "@/components/widgets/Title.vue";
import VideoCard from "@/components/cards/video/Index.vue";

export default {
  computed: {
    items() {
      return this.$rest("videos").list;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    md() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    getCardType() {
      return (i) => {
        if (this.xs) return i === 0 ? "featured" : "default";
        else if (this.md) return "default";
        else return i === 0 ? "featured" : "large";
      };
    },
    itemsPerPage() {
      if (this.xs) return 5;
      else if (this.md) return 6;
      else return 4;
    },
  },

  created() {
    this.$rest("videos").get({ params: { itemsPerPage: this.itemsPerPage } });
  },
  components: {
    Title,
    VideoCard,
  },
};
</script>

<style>
.page-home-videos-list {
  display: grid;
  grid-template-columns: 4fr 3fr;
  gap: 30px;
}
.page-home-videos-list > :nth-child(1) {
  grid-row-end: span 3;
}
@media screen and (max-width: 1264px) {
  .page-home-videos-list {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .page-home-videos-list > :nth-child(1) {
    grid-row-end: initial;
  }
}

@media screen and (max-width: 600px) {
  .page-home-videos-list {
    grid-template-columns: 1fr 1fr;
  }
  .page-home-videos-list > :nth-child(1) {
    grid-column-end: span 2;
  }
}
</style>
